<script>
    export default {
        name: 'NormalDropDown',
        props: {
            icon: {
                type: String,
                default: '&#xe805;',
                required: false
            },
            text: {
                type: String,
                required: true
            },
            options: {
                default () {
                    return [];
                },
                required: false
            },
            position: {
                default: 'absolute',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
        },
        data () {
            return {
                droped: false,
                dropX: 0,
                dropY: 0,
                dropR: 0,
            };
        },
        computed: {
            dropStyle () {
                const style = {
                    opacity: this.dropOpacity,
                    top: this.dropY + 'px',
                    position: this.position
                };
                style.left = `${ this.dropX }px`;
                if (this.dropR) {
                    style.right = `${ this.dropR }px`;
                    style.left = 'unset';
                } else {
                    style.right = 'unset';
                }
                return style;
            }
        },
        methods: {
            drop () {
                if (this.disabled === true) {
                    return false;
                }
                if (this.droped) {
                    this.fold();
                    return;
                }
                let limitWidth = document.documentElement.clientWidth;
                this.dropR = 0;
                this.droped = true;
                var that = this;
                var rect = this.$el.getBoundingClientRect();
                this.dropX = -9999;
                this.dropY = Math.round(rect.top) + 44;
                this.minWidth = Math.round(rect.width);

                this.$nextTick(() => {
                    this.droped = false;
                    const optRect = this.$refs.optionList.getBoundingClientRect();
                    const optWidth = optRect.width;
                    this.dropX = Math.round(rect.left) + rect.width / 2 - optWidth / 2;
                    if (limitWidth - (this.dropX + optWidth) < 10) {
                        this.dropR = 10;
                    }
                    this.$nextTick(() => {
                        this.droped = true;
                    });
                });

                //  - 28 - 2;
                this.outAreaMouseDown = function () {
                    if (that.hovering) {
                        return;
                    }
                    that.fold();
                };
                window.addEventListener('mousedown', this.outAreaMouseDown);
            },
            fold () {
                this.droped = false;
                window.removeEventListener('mousedown', this.outAreaMouseDown);
            },
            handleClick (item) {
                this.$emit('change', item.value);
                this.fold();
                return false;
            },
        },
        components: {},
        beforeDestroy () {
            document.body.removeChild(this.$refs.optionList);
        },
        mounted () {
            document.body.appendChild(this.$refs.optionList);
        },
    };
</script>

<template>
    <div class="nromal-dropdown"
         @click.stop="drop"
    >
        <span class="nromal-dropdown__icon" v-html="icon"></span>&nbsp;
        <span class="nromal-dropdown__text" v-html="text"></span>
        <transition name="fade">
            <div class="nromal-dropdown__options"
                 ref="optionList"
                 v-show="droped"
                 v-bind:style="dropStyle">
                <template>
                    <div class="nromal-dropdown__item"
                         v-for="item in options"
                         @click.stop="handleClick(item)"
                         :key="item.value"
                         v-html="item.text">
                    </div>
                </template>
            </div>
        </transition>
    </div>
</template>


<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .nromal-dropdown {
        display: flex;
        align-items: center;
        .px2rem(padding-right, 15);
        .px2rem(padding-left, 15);
        color: @whiteBg;

        &__options {
            box-sizing: border-box;
            .px2rem(padding-top, 20);
            .px2rem(padding-bottom, 20);
            .px2rem(font-size, 26);
            .px2rem(border-radius, 10);
            background: @whiteBg;
            position: absolute;
            z-index: 99;
        }

        &__item {
            box-sizing: border-box;
            .px2rem(padding-top, 5);
            .px2rem(padding-bottom, 5);
            .px2rem(padding-left, 20);
            .px2rem(padding-right, 20);
            cursor: pointer;

            &:hover {
                background: #eee;
            }
        }

        &__icon {
            font-family: cmsicon;
            .px2rem(height, 88);
            .px2rem(line-height, 88);
            .px2rem(font-size, 36);
        }

        &__text {
            .px2rem(font-size, 28);
        }
    }
</style>
